<script setup>
// Hedef Kitleler bolumunun kabugu.
//
// Kenar cubugu sisirmemek icin bolum tek girdi olarak durur; kitle listesi ve
// hedefleme aramasi sekmelerden acilir. Hesap secici kabukta oldugu icin iki
// sekme de ayni secili reklam hesabini paylasir.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import MetaAdsKabuk from './MetaAdsKabuk.vue';

const { t } = useI18n();

// Sekme etiketleri dile bagli oldugu icin computed; dil degisince yenilenir.
const sekmeler = computed(() => [
  { ad: t('META_ADS.HEDEF_KITLELER.SEKME.KITLELER'), rota: 'meta_ads_kitleler' },
  { ad: t('META_ADS.HEDEF_KITLELER.SEKME.HEDEFLEME'), rota: 'meta_ads_hedefleme' },
]);
</script>

<template>
  <MetaAdsKabuk
    :baslik="t('META_ADS.HEDEF_KITLELER.BASLIK')"
    :sekmeler="sekmeler"
    :hesap-gerekli="true"
  />
</template>
